var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import MuiIconButton from "@material-ui/core/IconButton";
import capitalize from "@material-ui/core/utils/capitalize";
import { getButtonAppearanceProps } from "../button";
import { makeStyles } from "../styles";
import clsx from "../utils/clsx";
import { useIconButtonContext } from "./icon-button-context";
export var IconButtonComponentName = "CosmosIconButton";
export var useIconButtonStyles = makeStyles(function (theme) { return ({
    root: {
        "&:focus,&.Mui-focusVisible": theme.mixins.focusRing(),
    },
    colorError: {
        color: theme.palette.error.main,
        "&:hover,&.Mui-hover": {
            backgroundColor: theme.mixins.shadeOfColor("red", "lightest"),
        },
        "&:active,&.Mui-active": {
            backgroundColor: theme.mixins.shadeOfColor("red", "lighter"),
        },
    },
    label: {},
    contained: {
        color: theme.palette.text.primary,
        backgroundColor: theme.mixins.shadeOfColor("neutral", "lighter"),
        "&:hover,&.Mui-hover": {
            backgroundColor: theme.mixins.shadeOfColor("neutral", "light"),
        },
        "&:active,&.Mui-active": {
            backgroundColor: theme.mixins.shadeOfColor("neutral", "base"),
        },
        "&$disabled": {
            color: theme.palette.text.secondary,
            backgroundColor: theme.mixins.shadeOfColor("neutral", "lighter"),
        },
    },
    containedPrimary: {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        "&:hover,&.Mui-hover": {
            backgroundColor: theme.palette.primary[700],
        },
        "&:active,&.Mui-active": {
            backgroundColor: theme.palette.primary[800],
        },
    },
    containedSecondary: {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.main,
        "&:hover,&.Mui-hover": {
            backgroundColor: theme.palette.secondary.dark,
        },
        "&:active,&.Mui-active": {
            backgroundColor: theme.palette.secondary.dark,
        },
    },
    containedError: {
        color: theme.palette.error.contrastText,
        backgroundColor: theme.mixins.shadeOfColor("red", "base"),
        "&:hover,&.Mui-hover": {
            backgroundColor: theme.mixins.shadeOfColor("red", "dark"),
        },
        "&:active,&.Mui-active": {
            backgroundColor: theme.mixins.shadeOfColor("red", "darker"),
        },
    },
    outlined: {
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: theme.palette.border.dark,
        backgroundColor: theme.palette.background.paper,
        "&$disabled": {
            borderColor: theme.palette.border.dark,
        },
    },
    outlinedPrimary: {
        borderColor: theme.palette.primary.main,
    },
    outlinedSecondary: {
        borderColor: theme.palette.secondary.main,
    },
    outlinedError: {
        borderColor: theme.palette.error.main,
    },
    sizeLarge: {
        height: theme.typography.pxToRem(40),
        width: theme.typography.pxToRem(40),
    },
    disabled: {},
}); }, { name: IconButtonComponentName });
export var IconButton = React.forwardRef(function (props, ref) {
    var classes = useIconButtonStyles(props);
    var iconButtonContext = useIconButtonContext();
    var className = props.className, children = props.children, _a = props.color, colorProp = _a === void 0 ? "default" : _a, _b = props.variant, variantProp = _b === void 0 ? "text" : _b, _c = props.size, size = _c === void 0 ? "medium" : _c, appearance = props.appearance, disabled = props.disabled, edgeProp = props.edge, 
    // remove to prevent passing through to the root
    propClasses = props.classes, iconButtonProps = __rest(props, ["className", "children", "color", "variant", "size", "appearance", "disabled", "edge", "classes"]);
    var edge = edgeProp != null ? edgeProp : iconButtonContext.edge;
    var _d = !!appearance
        ? getButtonAppearanceProps(appearance)
        : {
            color: colorProp,
            variant: variantProp,
        }, possibleColor = _d.color, variant = _d.variant;
    var color = possibleColor === "danger" ? "error" : possibleColor;
    return (React.createElement(MuiIconButton, __assign({ className: clsx([
            classes.root,
            variant && classes[variant],
            color && classes["color" + capitalize(color)],
            color && variant && classes["" + variant + capitalize(color)],
            size === "large" && classes.sizeLarge,
            disabled && classes.disabled,
            className,
        ]), color: color === "error" ? undefined : color, ref: ref, edge: edge, disabled: disabled, size: size !== "large" ? size : undefined, classes: {
            label: classes.label,
        } }, iconButtonProps), children));
});
